export const Paging = (currentPage, recordPerPage, data) => {

    //logic to display data
	const indexOfLastPlan = currentPage * recordPerPage;
	const indexOfFirstPlan = indexOfLastPlan - recordPerPage;
    let dividePages = data.slice(indexOfFirstPlan, indexOfLastPlan);
    return dividePages;
}
